import { useDecision } from '@optimizely/react-sdk'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import useRequest from '@space-shell/common/hooks/useRequest'
import { MentorshipEndpoints, MentorshipService } from '@space-shell/common/services/mentorship'
import { useMembershipStore } from '@space-shell/core/store'

const useGetSessions = () => {
  const [mentorshipFF] = useDecision('mcm_enable_mentorship')
  const { membershipSlug } = useMembershipStore()
  const { authStatus } = useAuthContext()

  const isUserAuthenticated = Boolean(authStatus === AuthStatus.AUTHENTICATED)

  return useRequest(
    [MentorshipEndpoints.getSessions(membershipSlug)],
    () => MentorshipService.getSessions(membershipSlug),
    {
      enabled: Boolean(mentorshipFF.enabled && isUserAuthenticated)
    }
  )
}

export default useGetSessions
